// @flow

// FadeableContainer is a container and sets styles to control visibility based
// on the given ContentVisibility (fading in/out or static). This component
// works well when used in conjunction with useTransitionManager and
// getVisibilityFromTransitionState.

import React, { type Node } from 'react';
import { Box } from 'gestalt';
import { DEFAULT_TRANSITION_DURATION_MS } from 'app/common/react/components/PinRep/Hooks/useTransitionManager';
import { type ContentVisibility } from 'app/common/react/components/PinRep/components/ContentVisibility';

export function buildFadeableStyles(fadeInDuration: number, fadeOutDuration: number) {
  return {
    hidden: {
      opacity: 0,
      transition: fadeOutDuration ? `opacity ${fadeOutDuration}ms ease` : undefined,
    },
    visible: {
      opacity: 1,
      transition: fadeInDuration ? `opacity ${fadeInDuration}ms ease` : undefined,
    },
  };
}

type Props = {|
  children?: Node,
  fadeInDuration?: number,
  fadeOutDuration?: number,
  visibility: ContentVisibility,
|};

export default function FadeableContainer({
  children,
  fadeInDuration = 0,
  fadeOutDuration = DEFAULT_TRANSITION_DURATION_MS,
  visibility,
}: Props) {
  if (visibility === 'none' || !children) {
    return null;
  }

  return (
    <Box
      dangerouslySetInlineStyle={{
        __style: buildFadeableStyles(fadeInDuration, fadeOutDuration)[visibility],
      }}
    >
      {children}
    </Box>
  );
}
